"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["fill"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*eslint-disable */
var _default = function _default(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#B2ADA6' : _ref$fill,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("g", {
    "data-testid": "night-cloudy-icon"
  }, /*#__PURE__*/_react["default"].createElement("path", _extends({}, rest, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6555 5.58631C9.55125 3.87083 9.9046 1.62751 11.3622 0C10.8322 0.13196 10.3463 0.351894 9.86043 0.6598C8.30544 1.6171 7.38385 3.18716 7.28101 4.75856C8.49119 5.07164 9.40522 6.06575 9.54619 7.32931C9.66046 7.27241 9.77473 7.27241 9.88899 7.27241C11.0273 7.27241 11.9388 8.17582 11.9457 9.30766C12.8924 9.27786 13.8696 8.99557 14.7632 8.44545C15.2491 8.13754 15.6466 7.78565 15.9999 7.38977C13.924 8.00558 11.7597 7.34578 10.6555 5.58631Z",
    fill: fill
  })), /*#__PURE__*/_react["default"].createElement("path", _extends({}, rest, {
    d: "M2.99366 7.33125C2.82421 7.33125 2.59827 7.275 2.37233 7.275C1.0732 7.275 0 8.34375 0 9.6375C0 10.9312 1.0732 12 2.37233 12H5.81787V5.25C4.51873 5.30625 3.38905 6.15 2.99366 7.33125Z",
    fill: fill
  })), /*#__PURE__*/_react["default"].createElement("path", _extends({}, rest, {
    d: "M11.2966 9.8625C11.2966 8.7375 10.3928 7.8375 9.26316 7.8375C9.15019 7.8375 9.03723 7.8375 8.92426 7.89375C8.7548 6.375 7.45567 5.25 5.87411 5.25H5.81763V12H9.26316C10.3364 11.8875 11.2966 10.9875 11.2966 9.8625Z",
    fill: fill
  })), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react["default"].createElement("path", _extends({}, rest, {
    d: "M1.89915 2.14773L3.04519 1.5L2.81598 2.86364L3.76556 3.81818L2.4558 4.02273L1.89915 5.25L1.30976 4.02273L0 3.81818L0.949575 2.86364L0.720368 1.5L1.89915 2.14773Z",
    fill: fill
  }))), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    y: "1.5",
    width: "3.76556",
    height: "3.75",
    fill: "white"
  }))));
};

exports["default"] = _default;